
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { TCompanyInfo } from "@/models/company_info";
import { SMUser } from "@/store";

const MESSAGES = {
  expiredWidget: {
    description: "<span>The company’s Compliance subscription has expired.</span>",
  },
};

@Component({
  components: {
    EmployeeCompanyItem: () =>
      import("@/pages/Layout/views/Employee/views/Company/components/EmployeeCompanyItem.vue"),
    ComplianceExpiredWidget: () => import("@/modules/Compliance/ComplianceExpiredWidget.vue"),
  },
})
export default class Company extends Vue {
  companyInfo: TCompanyInfo = {} as TCompanyInfo;

  messages = MESSAGES;

  async mounted() {
    await this.fetchCompanyInfo();
  }

  async fetchCompanyInfo() {
    const { data } = await this.axios.get(API_ROUTES.EMPLOYEE_COMPANY_INFO);

    if (!data) return;

    this.companyInfo = data;
  }

  get isComplianceBlocked() {
    return SMUser.user?.is_compliance_blocked;
  }
}
